export default __webpack_public_path__ + "static/media/Google.6e4f32c0.svg";